module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/acoustic-guitars-d8d16681273ea5bb25faa07cb94c4bd4.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/acoustic-guitars.png
// module id = amLl
// module chunks = 12 16 18